import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import WhyChoose from "@/sections/WhyChoose";
import Services from "@/sections/Services";
import FeaturedProducts from "@/sections/FeaturedProducts";
import Brands from "@/sections/Brands";
import Bitdefender from "@/sections/Bitdefender";
import Projects from "@/sections/Projects";
import Activities from "@/sections/Activities";
import Team from "@/sections/Team";
import Testimonials from "@/sections/Testimonials";
import Clients from "@/sections/Clients";
import Contact from "@/sections/Contact";
import KitCta from "@/sections/KitCta";
import MarqueeStrip from "@/components/MarqueeStrip";
import { scrollToId } from "@/lib/scroll";
import { api } from "@/lib/api";

const SECTION_COMPONENTS = {
  hero: Hero,
  marquee: MarqueeStrip,
  about: About,
  why: WhyChoose,
  services: Services,
  featured: FeaturedProducts,
  kit_cta: KitCta,
  brands: Brands,
  bitdefender: Bitdefender,
  projects: Projects,
  activities: Activities,
  team: Team,
  testimonials: Testimonials,
  clients: Clients,
  contact: Contact,
};

const DEFAULT_ORDER = Object.keys(SECTION_COMPONENTS);

// Merge a saved order with the default: known keys keep saved positions,
// new sections are inserted right after their default predecessor.
function mergeOrder(saved) {
  const valid = (saved || []).filter((s) => SECTION_COMPONENTS[s]);
  if (!valid.length) return DEFAULT_ORDER;
  const out = [...valid];
  for (const m of DEFAULT_ORDER.filter((s) => !valid.includes(s))) {
    let inserted = false;
    for (let p = DEFAULT_ORDER.indexOf(m) - 1; p >= 0; p--) {
      const at = out.indexOf(DEFAULT_ORDER[p]);
      if (at >= 0) {
        out.splice(at + 1, 0, m);
        inserted = true;
        break;
      }
    }
    if (!inserted) out.unshift(m);
  }
  return out;
}

export default function Landing() {
  const location = useLocation();
  const [order, setOrder] = useState(DEFAULT_ORDER);

  useEffect(() => {
    api
      .get("/settings/public")
      .then((r) => {
        const saved = Array.isArray(r.data?.section_order) ? r.data.section_order : [];
        setOrder(mergeOrder(saved));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const target = location.state?.scrollTo || location.hash?.replace("#", "");
    if (target) {
      const t = setTimeout(() => scrollToId(target), 350);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <main data-testid="landing-page">
      {order.map((key) => {
        const Section = SECTION_COMPONENTS[key];
        return Section ? <Section key={key} /> : null;
      })}
    </main>
  );
}
